import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 500,
    maxHeight: '80vh',
    '& .MuiDialogContent-root': {
      padding: theme.spacing(12)
    }
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    marginBottom: theme.spacing(6),
    lineHeight: 1.5
  },
  content: {
    maxHeight: 'calc(80vh - 200px)',
    overflowY: 'auto'
  },
  icon: {
    height: 32,
    marginBottom: theme.spacing(2)
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(7)
  },
  submitBtn: {
    padding: theme.spacing(1, 2),
    width: 150,
    height: 36
  },
  noBtn: {
    padding: theme.spacing(1, 2),
    minWidth: 137,
    height: 36
  },
  link: {
    color: theme.colorPalette.orange_10,
    textDecoration: 'underline !important',
    fontSize: 16,
    padding: theme.spacing(0),
    marginBottom: theme.spacing(1)
  },
  confirmModalContainer: {
    minWidth: 580,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.form__background_primary,
    padding: theme.spacing(6)
  }
}));

export default useStyles;
